import type { EnvironmentConfig } from '../../shared/types/common'

class Environment {
  private readonly _config: EnvironmentConfig

  constructor() {
    this._config = {
      apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.pod24.co.kr',
      isDevelopment: process.env.NODE_ENV === 'development',
      isProduction: process.env.NODE_ENV === 'production',
      version: process.env.REACT_APP_VERSION ?? '1.0.0',
    }
  }

  // 가장 많이 사용되는 속성들
  get apiBaseUrl(): string {
    return this._config.apiBaseUrl
  }

  // 전체 설정 객체 반환 (복사본)
  get config(): EnvironmentConfig {
    return { ...this._config }
  }
}

export const environment = new Environment()
